import config from "../config/app.conf.json";

export default () => ({
  url: config.api.organizations_uri,
  method: "GET"
});
